// localStream.js
// ★ 本地流处理器：完整克隆 StreamProcessor.fetchAndProcessData，
//   仅删除两处 store.dispatch('updateMessageToConversation')，
//   供「学习详情」弹窗使用 —— 消息自始至终不进主窗口 store，
//   从源头杜绝交互文本（诊断/闯关/回复选项）在主窗口出现副本。
import { getLevel } from '@/utils/chat/chatUtil';
import { getToken, getUser } from '@/utils/auth';

export const CONTENT_TYPE_JSON = "application/json;charset=utf-8";
export const SPLIT_SINAL = '}\n{';

// ★ 本地错误处理：克隆 FetchErrorHandler 的状态写入逻辑，
//   去掉 store.dispatch 与全局路由跳转/踢登录（弹窗流不干预全局会话）
function localSetErrorMessage(status, aiContent) {
  if (!['', 'loading'].includes(aiContent.msg)) return;
  aiContent.msg = "";
  aiContent.isDone = status;
  const messages = {
    2: '请求已取消',   // ABORT
    3: '网络出错',     // NETWORK
    401: '登录过期',   // EXPIRE（本地流仅标记，不踢登录）
    500: '服务器异常', // INTERAL
  };
  aiContent.msg = messages[status] || '服务器异常';
  if (aiContent.parts.length === 0) {
    aiContent.parts.push({ msg: aiContent.msg, questions: {} });
  }
}

export async function fetchLocalStream(url, data, handleDataFunction) {
  let readTimeout = null;
  let responseChunk = '';
  let parsedJson = null;
  let { question, aiContent, params } = data;

  let options = {
    method: 'POST',
    signal: params.signal,
  };
  options.headers = new Headers({
    "Content-Type": CONTENT_TYPE_JSON,
    "Authorization": getToken(),
    "username": getUser() && getUser().phoneNumber,
  });

  let level = "";
  const withOutLevelUrls = ["/Composition"];
  if (question && question.level) { level = question.level; }
  if (!level) { level = getLevel(); }
  if (!withOutLevelUrls.some(target => url.includes(target))) {
    const { signal, ...bodyParams } = params;
    options.body = JSON.stringify({ ...bodyParams, level });
  }

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      console.log(response.status);
      localSetErrorMessage(response.status || 3, aiContent);
    }

    const reader = response.body.getReader();

    async function readChunk() {
      const { done, value } = await reader.read();

      if (done) {
        console.log('全部数据接收完毕');
        if (aiContent) {
          aiContent.isDone = 1;
          if (aiContent.msg === "loading") { aiContent.msg = ""; }
          // ★ 已删除：store.dispatch('updateMessageToConversation', { message: aiContent })
        }
        clearTimeout(readTimeout);
        if (question) { question.isLoading = false; }
        reader.releaseLock();
        return;
      }

      clearTimeout(readTimeout);
      responseChunk += new TextDecoder().decode(value);

      if (responseChunk.includes(SPLIT_SINAL)) {
        responseChunk = responseChunk
          .replaceAll(SPLIT_SINAL, '},{')
          .replaceAll('}\n', '}')
          .split(',');
      }

      try {
        parsedJson = JSON.parse(`[${responseChunk}]`);
      } catch (error) {
        return readChunk();
      }

      if (parsedJson) {
        if (parsedJson instanceof Array) {
          for (const json of parsedJson) {
            handleDataFunction(json, aiContent, question);
          }
        } else {
          handleDataFunction(parsedJson, aiContent, question);
        }
        responseChunk = '';
      }

      return readChunk();
    }

    readChunk();
  } catch (error) {
    if (aiContent?._aborted) {
      clearTimeout(readTimeout);
      return;
    }
    // ★ 本地错误处理（替代 handleFetchError，无 store.dispatch）
    question && (question.isLoading = false);
    if (!aiContent) return;
    aiContent.isSlow = false;
    if (error.name === 'AbortError') {
      localSetErrorMessage(2, aiContent);
      console.log('Request aborted:', error);
    } else {
      localSetErrorMessage(3, aiContent);
      console.error('Request failed:', error);
    }
    // ★ 已删除：store.dispatch('updateMessageToConversation', ...)
  } finally {
    clearTimeout(readTimeout);
  }
}
